export default __webpack_public_path__ + "static/768-5bca364674ca2a2e812ccd6e68341600.gif";